import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  add_interview_kit_topic_question_mentor_action,
  delete_interview_kit_topic_mentor_action,
  delete_interview_kit_topic_question_mentor_action,
  update_interview_kit_action,
  update_interview_kit_topic_mentor_action,
  update_interview_kit_topic_question_mentor_action,
} from "../../../../redux/_actions/mentor";
import { questionSchema } from "../constants";

function useCreateAssessmentKitTopic(props) {
  const [formData, setFormData] = useState(props?.formData);
  const [formInputsError, setFormInputsError] = useState({});
  const [showCreateQuestion, setShowCreateQuestion] = useState(false);
  const [topicQuestions, setTopicQuestions] = useState({});
  const [addNewQuestion, setAddNewQuestion] = useState(false);
  const [editInterviewKitItemId, setEditInterviewKitItemId] = useState(null);

  const dispatch = useDispatch();

  const { interviewKitData } = useSelector(
    (state) => state.get_interview_kit_by_id_data_reducer
  );

  useEffect(() => {
    if (interviewKitData?.data) {
      setFormData(interviewKitData?.data);
    }
  }, [interviewKitData]);

  const onInterviewTopicEdit = (topic) => {
    setShowCreateQuestion(true);
    let data = topic;
    data["topic_name"] = topic?.name;
    data["rank"] = topic?.rank;
    data["skills"] =
      topic?.skill_names &&
      topic.skill_names.filter((item) => {
        return item.skill;
      });
    setTopicQuestions(data);
    setAddNewQuestion(true);
    setEditInterviewKitItemId(topic?.id);
    setFormInputsError({});
  };

  const onCreateNewTopic = () => {
    setShowCreateQuestion(true);
    let topicData = {
      topic_name: "",
      rank: 1,
      questions: [{ question: "", time_to_answer: null, rank: 1, skills: [] }],
    };
    setTopicQuestions(topicData);
    setAddNewQuestion(true);
    let data = formData;
    if (data?.topics) {
      formData.topics.push(topicData);
    }
    setFormData(data);
  };

  const onCancelTopicClick = () => {
    window.location.reload();
    setShowCreateQuestion(false);
    setEditInterviewKitItemId(null);
  };
  const onDeleteQuestion = async (questionIndex, question) => {
    if (question?.id) {
      await dispatch(
        delete_interview_kit_topic_question_mentor_action(question?.id)
      );
    }
    let specificArrayInObject = topicQuestions.questions.slice();
    specificArrayInObject.splice(questionIndex, 1);
    const newObj = { ...topicQuestions, ["questions"]: specificArrayInObject };
    setTopicQuestions(newObj);
  };

  const onSaveQuestion = async (question) => {
    let data = [{}];
    let error = formInputsError;
    data[0]["question"] = question?.question;
    data[0]["rank"] = question?.rank;
    data[0]["time_to_answer"] = question?.time_to_answer;
    data[0]["is_public"] = question?.is_public;
    data[0]["skills"] = question?.skills;
    if (question?.id) {
      let questionData = data[0];

      if (
        questionData.question === "" ||
        questionData.time_to_answer === null ||
        questionData.rank === null ||
        questionData.rank === "" ||
        questionData.time_to_answer === "" ||
        questionData.skills.length === 0
      ) {
        error["topic_error"] = "Please enter value in question fields.";
        setFormInputsError(error);
      } else {
        data[0]["rank"] = parseInt(question?.rank);
        data[0]["time_to_answer"] = parseInt(question?.time_to_answer);
        await dispatch(
          update_interview_kit_topic_question_mentor_action(
            questionData,
            question?.id
          )
        );
        setAddNewQuestion(true);
        setFormInputsError({});
      }
    } else {
      let questionData = data[0];

      if (
        questionData.question === "" ||
        questionData.time_to_answer === null ||
        questionData.rank === null ||
        questionData.rank === "" ||
        questionData.time_to_answer === "" ||
        questionData.skills.length === 0
      ) {
        error["topic_error"] = "Please enter value in question fields.";
        setFormInputsError(error);
      } else {
        data[0]["interview_kit_id"] = formData?.id;
        data[0]["topic"] = topicQuestions?.id;
        await dispatch(
          add_interview_kit_topic_question_mentor_action(data)
        );
        setAddNewQuestion(true);
        setFormInputsError({});
      }
    }
  };

  const onAddNewQuestion = () => {
    let specificArrayInObject = topicQuestions.questions.slice();
    specificArrayInObject.push({ ...questionSchema });
    const newObj = { ...topicQuestions, ["questions"]: specificArrayInObject };
    setTopicQuestions(newObj);
    setAddNewQuestion(false);
  };

  const onSaveTopicClick = async (id) => {
    let error = {};
    let valid = true;
    if (topicQuestions.topic_name === "" || topicQuestions.rank === null) {
      error["topic_error"] = "Please Enter Topic Title and Rank";
      valid = false;
    } else {
      let validQuestion = topicQuestions.questions.filter((item) => {
        return (
          item.question === "" ||
          item.time_to_answer === null ||
          item.rank === null ||
          item.rank === "" ||
          item.time_to_answer === ""
        );
      });

      if (validQuestion.length > 0) {
        error["topic_error"] = "Please enter value in question fields.";
        valid = false;
      }
    }
    if (valid) {
      let data = [];
      data[0] = topicQuestions;
      await dispatch(
        update_interview_kit_action({ topics: data }, formData?.id)
      );
      setShowCreateQuestion(false);
    } else setFormInputsError(error);
  };

  const onTopicDataChange = (e, questionIndex) => {
    let data = topicQuestions;
    let value = e.target.value;
    let name = e.target.name;
    if (
      name === "question" ||
      name === "time_to_answer" ||
      name === "questions_rank" ||
      name === "is_public" ||
      name === "skills"
    ) {
      if (name === "questions_rank") name = "rank";
      if (name === "skills") {
        data.questions[questionIndex].skills[0] = value;
        setTopicQuestions(data);
        return;
      }
      data.questions[questionIndex][name] = value;
    } else data[name] = value;
    setTopicQuestions(data);
  };

  const onTopicTitleChange = async (e) => {
    let data = {};
    let name = e.target.name;
    if (name === "topic_name") {
      name = "name";
    }
    data[name] = e.target.value;
    if (topicQuestions?.id) {
      await dispatch(
        update_interview_kit_topic_mentor_action(data, topicQuestions?.id)
      );
    } 
  };

  const onDeleteTopicClick = async () => {
    if (topicQuestions?.id) {
      await dispatch(
        delete_interview_kit_topic_mentor_action(topicQuestions?.id)
      );
      let specificArrayInObject = formData.topics.slice();
      let index = specificArrayInObject.findIndex(
        (x) => x.id === topicQuestions?.id
      );
      specificArrayInObject.splice(index, 1);
      const newObj = {
        ...formData,
        ["topics"]: specificArrayInObject,
      };
      setFormData(newObj);
      setShowCreateQuestion(false);
    }
  };

  return {
    formData,
    formInputsError,
    showCreateQuestion,
    topicQuestions,
    addNewQuestion,
    editInterviewKitItemId,
    onCreateNewTopic,
    onInterviewTopicEdit,
    onTopicDataChange,
    onTopicTitleChange,
    onSaveTopicClick,
    onAddNewQuestion,
    onSaveQuestion,
    onDeleteQuestion,
    onDeleteTopicClick,
    onCancelTopicClick,
  };
}

export default useCreateAssessmentKitTopic;
